import { Link } from "gatsby";
import React from "react";
import Button from "./ReusableComponents/Button/Button";
import Wrapper from "./ReusableComponents/Wrapper/Wrapper";
const CookieStrip = ({ setCookieStrip }) => {
  return (
    <div className="bg-[#F7E9D2] w-full fixed bottom-0 z-50">
      <div className="px-6  lg:px-4 max-w-7xl mx-auto flex lg:flex-row flex-col gap-5 justify-between  py-4 lg:items-center  ">
        <p className="text-black font-cairo text-sm max-w-5xl  text-justify">
          If you require any more information or have any questions about our{" "}
          <Link to="/privacy-policy" className="font-bold">
            Privacy Policy
          </Link>{" "}
          for Website and{" "}
          <Link to="/terms-and-conditions" className="font-bold">
            Terms of Use
          </Link>
          . For more information, please review our{" "}
          <Link to="/cookie-policy" className="font-bold">
            Cookie Policy
          </Link>
          .
        </p>
        <Button
          variant="primary"
          title="Accept Cookies"
          className="max-w-[180px]"
          onClick={() => {
            setCookieStrip(false);
            localStorage.setItem("cookie", JSON.stringify(true));
          }}
        />
      </div>
    </div>
  );
};

export default CookieStrip;
